/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-06 11:39:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { SkeletonDisplayText } from '@shopify/polaris';
import OptionItem from './option-item';

type Props = {
  options: Array<Object>,
  onSelect: Function,
  isFull?: boolean,
  loading: boolean
};
// DONE
class ListOptions extends Component<Props> {
  render() {
    // Render productRankings on table
    const rowsListOptions = this.buildRows();
    const { loading } = this.props;

    return (
      <div className="BC-Page__RecommendationGeneralSettings__SelectProductModal__Product-Options">
        <ul className="list-available">
          {rowsListOptions}
          {loading &&
            [...Array(5).keys()].map((item, key) => (
              <React.Fragment key={key}>
                <li>
                  <SkeletonDisplayText size="small" />
                </li>
              </React.Fragment>
            ))}
        </ul>
      </div>
    );
  }

  // Render rows for data table
  buildRows = () => {
    const { options, onSelect, isFull } = this.props;
    let rows = _.map(options, (item, index) => {
      return (
        <OptionItem item={item} index={index} key={index} onSelect={onSelect} isFull={isFull} />
      );
    });
    return rows;
  };
}

ListOptions.defaultProps = {
  isFull: false
};

export default ListOptions;
